import { Box, TableCell, TableRow, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import CatalistModal from "@/components/membership/Dashboard/DashboardComponents/CatalistModal";
import SummaryModal from "@/components/membership/Dashboard/DashboardComponents/SummaryModal";
import VANModal from "@/components/membership/Dashboard/DashboardComponents/VANModal";
import AreYouSureModal from "@/components/membership/Modals/AreYouSureModal";
import FileHistoryModal from "@/components/membership/Dashboard/DashboardComponents/FileHistoryModal";
import SiteIcons from "@/components/SiteIcons/SiteIcons";
import "@/components/membership/Dashboard/Dashboard.css";
import {
  canViewAllAffiliates,
  canSeeIEB,
  canDeleteDataFile,
} from "@/utils/permissionsHandler";
import { formatLargeNumber } from "@/utils/util";

function SubmittedFilesTableRow({
  row,
  index,
  user,
  handleDeleteFile,
  handleLocallyConfirmedFile,
  handleDownloadAffiliateFile,
  handleDownloadCatalistFile,
  handleUnstagedFile,
  handleIEBChange,
}) {
  return (
    <>
      <TableRow key={index} hover tabIndex={-1} sx={{ cursor: "pointer" }}>
        {/* processed date */}
        <TableCell align="left">
          {row.processDate?.replace("T", " ")}{" "}
        </TableCell>

        {/* data file name */}
        <TableCell align="left" className="dashboardstyle-tableColumn">
          {row.fileName}
        </TableCell>

        {/* local name */}
        {canViewAllAffiliates(user) && (
          <TableCell align="left" className="dashboardstyle-tableColumn">
            <Box>{row.local_name}</Box>
            <Box className="dashboardstyle-uploader">{row.uploader}</Box>
          </TableCell>
        )}

        {/* number of rows in file */}
        <TableCell align="right">{formatLargeNumber(row.num_rows)}</TableCell>

        {/* processed/confirmed */}
        <TableCell align="center">
          <SummaryModal
            row={row}
            handleDeleteFile={handleDeleteFile}
            handleConfirmFile={handleLocallyConfirmedFile}
            handleUnstagedFile={handleUnstagedFile}
            key={`confirmation-modal-for-row-${index}`}
            handleIEBChange={handleIEBChange}
          />
        </TableCell>

        {/* catalist */}
        <TableCell align="center">
          <CatalistModal row={row} />
        </TableCell>

        {/* VAN */}
        <TableCell>
          <VANModal row={row} />
        </TableCell>

        {/* IEB approved */}
        {canSeeIEB(user) && (
          <TableCell align="center">
            {row.IEB_approved && <SiteIcons iconstring="basicCheck" />}
          </TableCell>
        )}

        {/* file actions */}
        <TableCell align="center">
          <Box className="submitted-files-table-row-actions">
            {!row.confirmed && canDeleteDataFile(user) ? (
              <AreYouSureModal
                id={row.ada_file}
                handleAction={handleDeleteFile}
                title={"Delete this file"}
              />
            ) : null}
          </Box>
          <Box className="submitted-files-table-row-actions">
            {row.confirmed && (
              <span>
                <FileHistoryModal row={row} />
              </span>
            )}
          </Box>
          <Box className="submitted-files-table-row-actions">
            <Tooltip title="Download affiliate data file">
              <SiteIcons
                iconstring="download"
                onClick={() => handleDownloadAffiliateFile(row)}
                page="dashboard"
              />
            </Tooltip>
          </Box>
          <Box className="submitted-files-table-row-actions">
            {row.catalist?.completed ? (
              <Tooltip title="Download Catalist file">
                <SiteIcons
                  iconstring="description"
                  color="gray"
                  page="dashboard"
                  onClick={() => handleDownloadCatalistFile(row)}
                />
              </Tooltip>
            ) : null}
          </Box>
        </TableCell>
      </TableRow>
    </>
  );
}

SubmittedFilesTableRow.propTypes = {
  row: PropTypes.object,
  index: PropTypes.number,
  user: PropTypes.object,
  handleDeleteFile: PropTypes.func,
  handleLocallyConfirmedFile: PropTypes.func,
  handleDownloadAffiliateFile: PropTypes.func,
  handleDownloadCatalistFile: PropTypes.func,
};

export default SubmittedFilesTableRow;
